import React, { useCallback, useRef, useState } from 'react'
import { debounce } from 'lodash'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useResizeObserver } from 'hooks/useResizeObserver'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import { minWidthDecorator } from './minWidthDecorator'
import { AuthorStyles } from '../index.css'

const StyledAuthorLink = styled.a.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.authorName
})`
  ${AuthorStyles}
  text-decoration: none;
  overflow: hidden;
`

const StyledLinkedAuthorName = styled.div`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
`

const StyledAuthorName = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.authorName
})`
  ${AuthorStyles}
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.primary};
`

type LinkedAuthorProps = {
  name?: string
  url?: string
}

const LinkedAuthor = ({ name, url }: LinkedAuthorProps) => {
  const theme = useDisplayTheme() as Theme
  const [displayTooltip, setDisplayTooltip] = useState(false)
  const cellContentRef = useRef<HTMLDivElement>(null)

  const checkCellContent = () => {
    if (!cellContentRef.current) return
    const cellContent = cellContentRef.current

    if (!displayTooltip) {
      setDisplayTooltip(cellContent?.scrollHeight > cellContent?.clientHeight)
    }
  }

  useResizeObserver(
    cellContentRef,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(debounce(checkCellContent, 10), [])
  )

  const authorLinkRef = useCallback(minWidthDecorator, [])

  return url ? (
    <StyledAuthorLink
      href={url}
      target="_blank"
      rel="noreferrer"
      ref={authorLinkRef}
      onClick={(event) => {
        event.stopPropagation()
      }}>
      <StyledLinkedAuthorName mode={theme} ref={cellContentRef as React.RefObject<HTMLDivElement>}>
        <Tooltip mode={theme} enabled={displayTooltip} content={name}>
          <span>{name}</span>
        </Tooltip>
      </StyledLinkedAuthorName>
    </StyledAuthorLink>
  ) : (
    <StyledAuthorName mode={theme} ref={cellContentRef as React.RefObject<HTMLDivElement>}>
      <Tooltip mode={theme} enabled={displayTooltip} content={name}>
        <span>{name}</span>
      </Tooltip>
    </StyledAuthorName>
  )
}

export default LinkedAuthor
